<app-layout>
  <div class="main">
    <div class="header-table">
      <div class="title">
        <app-titulo>Usuário</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Cadastrar Funcionário"
          icon="assets/add.svg"
          (click)="navegarCadastroFuncionario()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Usuários Cadastrados <br /></div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getFuncionario()">
            <div class="table-filters">
              <app-input
                label="Nome do Usuário"
                width="100%"
                placeholder="Pesquisar"
                name="NM_FUNC"
                formControlName="NM_FUNC" />
              <app-input
                type="select"
                placeholder="Selecione"
                label="Qtd. Itens da lista"
                name="QTD_ITEM_LIST"
                formControlName="QTD_ITEM_LIST"
                [selectData]="qtdOptions"
                (ngModelChange)="escolherQtdLista($event)"
                width="100%" />
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Nome do Usuário"
        width="100%"
        placeholder="Pesquisar"
        name="NM_FUNC"
        formControlName="NM_FUNC" />
      <app-input
        type="select"
        placeholder="Selecione"
        label="Qtd. Itens da lista"
        name="QTD_ITEM_LIST"
        formControlName="QTD_ITEM_LIST"
        [selectData]="qtdOptions"
        (ngModelChange)="escolherQtdLista($event)"
        width="100%" />
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
